// The Falcon logo band on the sign-in screens (sign in, two-factor, password links, Choose an organisation, the
// one-time agreement) and the two "reloading" / "can't be reached" pages. One place, so every sign-in screen on
// app.falconplm.com and test.falconplm.com shows the same brand: the white text logo (no bird): FALCON on top, a line, PLM | CRM below, kept small.
import { esc } from "./lib.js";

export const FALCON_LOGO_SRC = "/img/falcon-text-logo.webp";

/** The slim navy band at the top of the card with the white Falcon PLM | CRM text logo and an optional line under it. */
export function authBrandHtml(tagline: string): string {
  return `<div class="falcon-auth-brand">
      <img class="falcon-auth-logo" src="${FALCON_LOGO_SRC}" alt="Falcon PLM | CRM" width="400" height="120" decoding="async">
      ${tagline ? `<span class="falcon-auth-tagline">${esc(tagline)}</span>` : ""}
    </div>`;
}
